var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "motivation-section" }, [
      _c("h2", [_vm._v("Fun and challenging STEM lessons and problems")]),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row icon" }, [
            _c("span", { staticClass: "b-sprite-bfe-explore-why" })
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v('Explore the "why"')]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Have your students ever asked you why they need to learn something? Brilliant’s courses\n        cultivate natural curiosity and guide learners to mastery through intuition, not formulas.\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row icon" }, [
            _c("span", { staticClass: "b-sprite-bfe-learn-by-doing" })
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("Learn by doing")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Studies show that interactive problem solving is\n        "
            ),
            _c("a", { attrs: { href: "/principles" } }, [
              _vm._v("more effective")
            ]),
            _vm._v(
              " than lectures. Brilliant will let your students\n        explore and challenge them to think outside the box.\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row icon" }, [
            _c("span", { staticClass: "b-sprite-bfe-love-of-learning" })
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("Inspire a love of learning")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Brilliant creates a culture of learning around inquiry, curiosity, and openness to\n        failure. Solve fascinating, challenging problems and sometimes fail trying.\n      "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }